module.exports = __webpack_public_path__ + "img/productions_17.112e03ca.png";